import { useApiUtils } from '@core/util/apiUtils';
import FusePageCarded from '@fuse/core/FusePageCarded';
import { useDebounce } from '@fuse/hooks';
import { gestaoEnvioApi } from 'app/services/api/gestaoEnvioApi';
import * as Actions from 'app/store/actions';
import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { GestaoEnvioContext, GestaoEnvioProvider } from './GestaoEnvioContext';
import GestaoEnvioHeader from './components/gestaoEnvioHeader/GestaoEnvioHeader';
import GestaoEnvioTable from './components/gestaoEnvioTable/GestaoEnvioTable';
import GestaoEnvioBuscaAvancadaModal from './components/modal/gestaoEnvioBuscaAvancada/GestaoEnvioBuscaAvancadaModal';
import GestaoEnvioGraficosModal from './components/modal/gestaoEnvioGraficos/GestaoEnvioGraficosModal';
import VisualizarGestaoEnvioModal from './components/modal/gestaoEnvioVisualizar/VisualizarGestaoEnvioModal';

const GestaoEnvio = () => {
  const [, setGestoesEnvio] = useContext(GestaoEnvioContext).gestoesEnvio;
  const [, setGestaoEnvioAtual] = useContext(GestaoEnvioContext).gestaoEnvioAtual;
  const [, setLoading] = useContext(GestaoEnvioContext).loading;
  const [, setPage] = useContext(GestaoEnvioContext).page;
  const [, setSize] = useContext(GestaoEnvioContext).size;
  const [, setTotalElements] = useContext(GestaoEnvioContext).totalElements;
  const [filtroAvancado] = useContext(GestaoEnvioContext).filtroAvancado;
  const [, setSomatorios] = useContext(GestaoEnvioContext).somatorios;

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  const initialPage = {
    page: 0,
    q: '',
    size: 15,
    sort: 'dataHoraEnvio,DESC',
  };

  useEffect(() => {
    fetchGestoesEnvio();
    // Efeito de montagem: roda uma única vez. Incluir as dependências reexecutaria a carga
    // inicial a cada render (loop de chamadas à API).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchGestoesEnvio = async (search = initialPage) => {
    setLoading(true);
    try {
      if (!search?.filtroAvancado) {
        search.filtroAvancado = filtroAvancado;
      }
      const resp = await gestaoEnvioApi().buscarGestaoEnvio(search);
      setGestoesEnvio(resp.data.content);
      setPage(resp.data.number);
      setSize(resp.data.size);
      setTotalElements(resp.data.totalElements);
      fetchSomatorio({ ...search, size: 10000000, page: 0 });
    } catch (err) {
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchGestaoEnvio = async (gestaoEnvioId) => {
    setLoading(true);
    try {
      const resp = await gestaoEnvioApi().buscarPeloId(gestaoEnvioId);
      setGestaoEnvioAtual(resp.data);
    } catch (err) {
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchSomatorio = useDebounce(async (search) => {
    if (!search?.filtroAvancado) {
      search.filtroAvancado = filtroAvancado;
    }
    const res = await gestaoEnvioApi().buscarSomatorioGestaoEnvio(search);

    setSomatorios(res.data);
  });

  return (
    <FusePageCarded
      innerScroll
      header={<GestaoEnvioHeader />}
      content={
        <>
          <GestaoEnvioTable fetchGestoesEnvio={fetchGestoesEnvio} fetchGestaoEnvio={fetchGestaoEnvio} />
          <GestaoEnvioBuscaAvancadaModal fetchGestoesEnvio={fetchGestoesEnvio} />
          <GestaoEnvioGraficosModal />
          <VisualizarGestaoEnvioModal />
        </>
      }
    />
  );
};

const GestaoEnvioContainer = () => {
  return (
    <GestaoEnvioProvider>
      <GestaoEnvio />
    </GestaoEnvioProvider>
  );
};

export default GestaoEnvioContainer;
